<template>
    <div :class="preCls + 'container-padding'">
        <div :class="preCls + 'content-box'">
            <table-tool-bar>
                <Button v-if="$can('add')"
                    :class="preCls + 'button-margin'"
                    :disabled="loading"
                    type="primary"
                    @click="onClickAdd">
                    新增
                </Button>
            </table-tool-bar>
            <Table ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight">
                <!-- 操作列 -->
                <template v-slot:action="{ row }">
                    <Button type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickEdit(row)">
                        详情
                    </Button>
                    <PoptipButton v-if="$can('delete')"
                        text="删除" transfer
                        type="default"
                        title="您确定删除这条记录吗？"
                        :ok="() => { rowConfirmDelete(row) }">
                    </PoptipButton>
                </template>
                <template v-slot:imgs="{ row }">
                    <base-img v-for="(item, index) in getImgPath(row)" 
                        :key="index" height="30" width="30" 
                        type="path" :src="item"
                        style="margin-left: 5px;">
                    </base-img>
                </template>
            </Table>
            <!-- 底部分页 -->
            <table-pager :total.sync="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.page"
                @change="fetch">
            </table-pager>
            <!-- 弹出层 -->
            <smart-modal v-model="modal.showBrandForm"
                :title="curId ? '品牌编辑' : '品牌登记'"
                :width="800"
                :height="650"
                :maskClosable="false"
                :buttons.sync="formBtns"
                @close-by-confirm="search">
                <form-brand v-if="modal.showBrandForm" :id="curId"></form-brand>
            </smart-modal>
        </div>
    </div>
</template>
<script>
import { mapCell } from '_c/grid/renderCell'
import FormBrand from './form-brand'
import { brandList, brandDelete } from '@/api/brand-manage'
import Dict from '_u/dict'
import BaseImg from '@/components/base-img'
const PAGE_SIZE = 20

export default {
    name: 'ListBrand',

    components: {
        FormBrand,
        BaseImg
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            filter: {
                page: 1,
                pageSize: PAGE_SIZE,
                search: ''
            },
            page: {
                total: 0,
                list: []
            },
            dict: {
                serviceType: Dict.NULL,
                busType: Dict.NULL
            },
            modal: {
                showBrandForm: false
            },
            curId: '',
            formBtns: []
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60
                },
                {
                    key: 'serviceType',
                    title: '服务类别',
                    align: 'center',
                    minWidth: 100,
                    render: mapCell(this.dict.serviceType.val())
                },
                {
                    key: 'busType',
                    title: '业务类别',
                    align: 'center',
                    minWidth: 100,
                    render: mapCell(this.dict.busType.val())
                },
                {
                    key: 'brandName',
                    title: '品牌名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true
                },
                {
                    key: 'attachments',
                    title: '业务图片',
                    align: 'center',
                    minWidth: 140,
                    slot: "imgs"
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 200,
                    fixed:"right",
                    slot: 'action'
                }
            ]
        }
    },

    created() {
        Promise.all([
            Dict.get(['service_type', 'bus_type'])
        ]).then(args => {
            var [dictGroup, page] = args
            Object.keys(this.dict).forEach(name => {
                this.dict[name] = dictGroup[name]
            })
        }).then(args => {
            this.fetch()
        })
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true
            Promise.all([brandList(this.filter)])
                .then(args => {
                    var [page] = args
                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.page = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        onClickAdd(e) {
            this.curId = ''
            this.modal.showBrandForm = true
        },

        rowClickEdit(row) {
            this.curId = row.id
            this.modal.showBrandForm = true
        },

        rowConfirmDelete(row) {
            this.loading = true
            brandDelete(row.id)
                .then(el => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .finally(() => {
                    this.fetch()
                })
        },
        
        getImgPath(row) {
            let arr = JSON.parse(row.attachments || "[]")
            return arr.map(el=> el.path)
        }
    }
}
</script>
<style lang="less" 
    scoped>
</style>